// import { createSelector } from 'reselect';

export const getIsPutting = state => state.getIn(['appointmentCustodian', 'isPutting']);
export const getErrMsg = state => state.getIn(['appointmentCustodian', 'errMsg']);